import React from "react";
import { Link } from "react-router-dom";

// const navNotOpenClass = `ml-4 lg:px-8 px-4 py-4 rounded-md text-lg font-medium`;
// const navOpenClass = `block px-3 py-2 rounded-md text-base font-medium text-white`;

export const NavItem = ({link, currentRoute, setCurrentRoute, isNavOpen, text, isGithub}) => {
    return (     
      <>
        {isGithub ? 
          <Link
          className={` lg:px-4 px-4 py-4 rounded-md text-lg font-medium text-simple-gray-1e transition duration-150 ease-in hover:text-sky-500`}
          onClick={()=>window.location.replace(link)}
          >
          {text}
          </Link>
          :
          <Link
          to={link}
          className={` flex-row lg:px-4 px-4 py-4 rounded-md text-lg font-medium text-simple-gray-1e transition duration-150 ease-in hover:text-sky-500`}
          onClick={()=>setCurrentRoute(link)}
          >
          {text}
          </Link>
        }
      </>
    );
}